import PDFLink from './PDFLink.vue'

export default PDFLink
